export const PermissionCode = {
  ClientsViewList: 'clients.view_list',
  ClientsViewNameAddress: 'clients.view_name_address',
  ClientsViewContact: 'clients.view_contact',
  ClientsViewAdditional: 'clients.view_additional',
  ClientsViewProfile: 'clients.view_profile',
  ClientsCreate: 'clients.create',
  ClientsEdit: 'clients.edit',
  ClientsDelete: 'clients.delete',
  AppointmentsViewList: 'appointments.view_list',
  AppointmentsView: 'appointments.view',
  AppointmentsViewInfo: 'appointments.view_info',
  AppointmentsCreate: 'appointments.create',
  AppointmentsEdit: 'appointments.edit',
  AppointmentsCancel: 'appointments.cancel',
  EstimatesViewList: 'estimates.view_list',
  EstimatesViewDetails: 'estimates.view_details',
  EstimatesCreate: 'estimates.create',
  EstimatesEdit: 'estimates.edit',
  EstimatesCancel: 'estimates.cancel',
  EstimatesCopy: 'estimates.copy',
  EstimatesApprove: 'estimates.approve',
  EstimatesSend: 'estimates.send',
  EstimatesViewNotes: 'estimates.view_notes',
  EstimatesEditNotes: 'estimates.edit_notes',
  EstimatesManageFollowUps: 'estimates.manage_follow_ups',
  JobsViewAssigned: 'jobs.view_assigned',
  JobsViewAll: 'jobs.view_all',
  JobsViewNotes: 'jobs.view_notes',
  JobsEditNotes: 'jobs.edit_notes',
  JobsEdit: 'jobs.edit',
  JobsSchedule: 'jobs.schedule',
  JobsDownload: 'jobs.download',
  JobsCancel: 'jobs.cancel',
  JobsHold: 'jobs.hold',
  JobsTimers: 'jobs.timers',
  JobsEditCrewHours: 'jobs.edit_crew_hours',
  JobsComplete: 'jobs.complete',
  JobsViewTimePrice: 'jobs.view_time_price',
  JobsViewBidSummary: 'jobs.view_bid_summary',
  InvoicesViewList: 'invoices.view_list',
  InvoicesView: 'invoices.view',
  InvoicesCreate: 'invoices.create',
  InvoicesMarkPaid: 'invoices.mark_paid',
  InvoicesSend: 'invoices.send',
  InvoicesSendReceipt: 'invoices.send_receipt',
  InvoicesEdit: 'invoices.edit',
  InvoicesViewNotes: 'invoices.view_notes',
  InvoicesEditNotes: 'invoices.edit_notes',
  InvoicesManageDueDates: 'invoices.manage_due_dates',
  TeamViewJobCrew: 'team.view_job_crew',
  TeamViewList: 'team.view_list',
  TeamCreate: 'team.create',
  TeamEdit: 'team.edit',
  TeamDelete: 'team.delete',
  SettingsEmailIntegrations: 'settings.email_integrations',
  SettingsCalendarIntegrations: 'settings.calendar_integrations',
  SettingsImageUploadQuality: 'settings.image_upload_quality',
  SettingsPricing: 'settings.pricing',
  SettingsCompanyGoals: 'settings.company_goals',
  SettingsBilling: 'settings.billing',
  EquipmentViewJob: 'equipment.view_job',
  EquipmentViewList: 'equipment.view_list',
  EquipmentCreate: 'equipment.create',
  EquipmentEdit: 'equipment.edit',
  EquipmentDelete: 'equipment.delete',
  RbacManage: 'rbac.manage',
  LibraryCurate: 'library.curate',
} as const;

export type PermissionCodeType = typeof PermissionCode[keyof typeof PermissionCode];

export interface MeGroupDto {
  id: number;
  name: string;
  systemKey: string | null;
}

export interface MeDto {
  id: number;
  firebaseUid: string;
  email?: string | null;
  name: string;
  isAdmin: boolean;
  /** SQ-500: may prepare this company's completed jobs for the comparable library. */
  canCurateLibrary?: boolean;
  /** SQ-419: has not accepted the current Terms of Service and Privacy Policy (LegalAcceptanceGate). */
  legalAcceptanceRequired?: boolean;
  permissions: string[];
  groups: MeGroupDto[];
}

export interface PermissionCatalogItem {
  id: number;
  code: string;
  featureArea: string;
  description: string;
}

export interface RbacRoleDto {
  id: number;
  companyId: number;
  name: string;
  systemKey: string | null;
  permissionCodes: string[];
}

export interface RbacGroupDto {
  id: number;
  companyId: number;
  name: string;
  systemKey: string | null;
  roleIds: number[];
}

export interface RbacCompanyUserDto {
  id: number;
  email?: string | null;
  name: string;
  groupIds: number[];
  phoneNumber?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  dateOfBirth?: string | null;
  hireDate?: string | null;
  hourlyPay?: number | null;
  annualSalary?: number | null;
  billableHourlyRate?: number | null;
  hoursWorked?: {startDate?: string | null; days: {day: string; hours: number}[]}[] | null;
  isActive?: boolean;
  canDelete?: boolean;
}
